import { useState } from 'react'
import { View } from 'react-native'
import {
  useAuthStatus,
  useFilmGroupListQuery,
  useSubscriptionPlansQuery,
} from '@mwxltd/flix-api-client'
import {
  RegisterAccount,
  RegisterAccountPromos,
  RegisterBackground,
} from '@flix/common/domain/membership'
import { findMonthlyPlan } from '@flix/common/domain/subscriptions/helpers'
import compose from '@flix/common/utils/compose'
import { scrollTo } from '../../../../components/common/scrollTo/scrollTo'
import { ifNotChosenPlanGoTo, ifSubscribedGoTo } from '../../../routeGuards/routeGuards'
import { SUBSCRIBE_WIZARD_PATH } from '../../constants'
import { useWizardState } from '../../useWizardState'
import { PayPalCheckoutContent } from './PayPalCheckoutContent'
import { RegisterAndSubscribeForm } from './RegisterAndSubscribeForm'

const Step2Subscribe = ({ history }) => {
  const { chosenPlan, marketingSource, setChosenPlan } = useWizardState()
  const authStatus = useAuthStatus()
  const {
    data: { plans },
  } = useSubscriptionPlansQuery({
    provider: 'stripe' + (marketingSource ? `?marketingSource=${marketingSource}` : ''),
  })

  const { data: filmsData } = useFilmGroupListQuery({
    groupSlug: 'now-showing',
    listSlug: 'trend',
    limit: 30,
  })
  const films = filmsData?.filmGroupList.items ?? []
  const monthlyPlan = findMonthlyPlan(plans)

  const [payPalCheckout, setPayPalCheckout] = useState(false)

  const onChangePlan = () => {
    setChosenPlan(null)
    history.replace(`${SUBSCRIBE_WIZARD_PATH}/choose-plan`)
  }

  return (
    <View>
      <RegisterBackground />

      {payPalCheckout ? (
        <PayPalCheckoutContent
          chosenPlan={chosenPlan}
          onRequestChange={onChangePlan}
          onPressTerms={() => history.push('/terms')}
          onPressPolicy={() => history.push('/privacy')}
        />
      ) : (
        <RegisterAccount
          authStatus={authStatus}
          chosenPlan={chosenPlan}
          onRequestChange={onChangePlan}
          onPressSignIn={() => history.push('/sign-in')}
          onPressTerms={() => history.push('/terms')}
          onPressPolicy={() => history.push('/privacy')}
        >
          <RegisterAndSubscribeForm
            authStatus={authStatus}
            chosenPlan={chosenPlan}
            marketingSource={marketingSource}
            onPayPalSubmit={() => {
              setPayPalCheckout(true)
              scrollTo({ top: 0 })
            }}
          />
        </RegisterAccount>
      )}

      <RegisterAccountPromos
        chosenPlan={chosenPlan}
        monthlyPlan={monthlyPlan}
        onSignUpPress={() => scrollTo({ top: 0 })}
        films={films}
      />
    </View>
  )
}

export default compose(
  ifNotChosenPlanGoTo(`${SUBSCRIBE_WIZARD_PATH}/choose-plan`),
  ifSubscribedGoTo(`${SUBSCRIBE_WIZARD_PATH}/verify`),
)(Step2Subscribe)
